import { useSelector } from 'react-redux';
import { useRouteParams } from '../Goals/hooks/useRouteParams';
import { fpIdSelector } from '../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import { useIsPdf } from './useIsPdf';

export const useFpId = (): string => {
  const isPdf = useIsPdf();

  if (isPdf) {
    return ADV.data.fpId;
  }

  const { clientId } = useRouteParams();

  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  return useSelector(state => fpIdSelector(state, { clientId }));
};
